<div class="Home-container">
  <ng-container *ngIf="hasHomeslider">
    <div class="home-slider-wrapper home-container-wrapper">
      <div class="aspect-ratio-box">
        <div class="aspect-ratio-box-inside">
          <swiper slider class="swiper-container" [config]="homeSliderconfig">
            <ng-container *ngFor="let homeSlider of homeSliders">
              <div slider class="home-swiper-item" (click)="setTargetNavigation(homeSlider)">

                <div a11y_NoAria class="img" *ngIf="!isSmallView">
                  <img class="ya_image" [src]="homeSlider.imagePhoto" alt="">
                  <div class="gradient"></div>
                </div>

                <img class="ya_image" [src]="homeSlider.imagePhoto" *ngIf="isSmallView" alt="">

                <ng-container *ngIf="homeSlider.show_label">
                  <div class="home-label-content">
                    <h2>{{homeSlider.label}}</h2>
                  </div>
                </ng-container>

              </div>
            </ng-container>
          </swiper>
        </div>
      </div>
    </div>
  </ng-container>

  <div id="userProfileDetail" class="viewing-choice">
    <ng-container *ngIf=" ordertypes$ | async; let ordertypes">
      <div [@serviceButtonEntering]="ordertypes"
        class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
        <ng-container>
          <ng-container *ngFor="let ordertype of ordertypes; trackBy: trackOrdertypesBy">
            <ng-container *ngIf="ordertype.show_on_startpage">
              <div a11y_Button class="choice" (click)="checkService(ordertype.id)">
                <div class="inline-icon" inlineSVG="{{ordertype.iconFilename}}"></div>
                <div class="title">{{ordertype.label}}</div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="isSmallView && hasFirstRowHomeTile">
    <div class="home-firstroetile-wrapper home-container-wrapper">
      <ng-container *ngFor="let firstRowTile of firstRowHomeTileList">
        <div a11y_Button class="home-tile-container">
          <div class="aspect-equal-ratio-box">
            <div class="aspect-ratio-box-inside" (click)="setTargetNavigation(firstRowTile)">
              <div class="aspect-ration-img-box">
                <img class="ya_image" [src]="firstRowTile.imagePhoto" alt="">
                <ng-container *ngIf="firstRowTile.show_label">
                  <div class="img-label-content">
                    <h2>{{firstRowTile.label}}</h2>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="isSmallView && hasHomePriority">
    <div a11y_Button class="home-prioritytile-wrapper home-container-wrapper">
      <div class="aspect-ratio-box">
        <div class="aspect-ratio-box-inside">
          <ng-container *ngIf="homePriorityList.length === 1; then priorityImageTemplate else prioritySwiperTemplate">
          </ng-container>
          <ng-template #priorityImageTemplate>
            <div class="aspect-ration-img-box" (click)="setTargetNavigation(homePriorityList[0])">
              <img class="ya_image" [src]="homePriorityList[0].imagePhoto" alt="">
              <ng-container *ngIf="homePriorityList[0].show_label">
                <div class="home-label-content">
                  <h2>{{homePriorityList[0].label}}</h2>
                </div>
              </ng-container>
            </div>
          </ng-template>
          <ng-template #prioritySwiperTemplate>
            <swiper class="swiper-container" [config]="homePriorityTileconfig">
              <ng-container *ngFor="let homePriorityTile of homePriorityList">
                <div a11y_Button class="home-swiper-item" (click)="setTargetNavigation(homePriorityTile)">
                  <img class="ya_image" [src]="homePriorityTile.imagePhoto" alt="">
                  <ng-container *ngIf="homePriorityTile.show_label">
                    <div class="home-label-content">
                      <h2>{{homePriorityTile.label}}</h2>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </swiper>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isSmallView && hasHomeTile">
    <div class="home-tile-wrapper home-container-wrapper">
      <ng-container *ngFor="let homeTile of homeTileList">
        <div a11y_Button class="home-tile-container home-container-wrapper">
          <div class="aspect-equal-ratio-box">
            <div class="aspect-ratio-box-inside" (click)="setTargetNavigation(homeTile)">
              <div class="aspect-ration-img-box">
                <img class="ya_image" [src]="homeTile.imagePhoto" alt="">
                <ng-container *ngIf="homeTile.show_label">
                  <div class="home-label-content">
                    <h2>{{homeTile.label}}</h2>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <div>
    <ng-container *ngIf="!isSmallView">
      <!--New Module tiles for desktop-->

      <div class="desktop-tiles" [class.expanded]="areDesktopTilesExpanded"
        [class.hasPriortySlide]="homePriorityList && homePriorityList.length > 0">
        <ng-container *ngIf="hasFirstRowHomeTile">
          <ng-container *ngFor="let firstRowTile of firstRowHomeTileList">
            <div a11y_Button class="home-tile-container">
              <div class="aspect-equal-ratio-box">
                <div class="aspect-ratio-box-inside" (click)="setTargetNavigation(firstRowTile)">
                  <div class="aspect-ration-img-box">
                    <img class="ya_image" [src]="firstRowTile.imagePhoto" alt="">
                    <ng-container *ngIf="firstRowTile.show_label">
                      <div class="img-label-content">
                        <h2>{{firstRowTile.label}}</h2>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="hasHomePriority">
          <div a11y_Button class="home-prioritytile-wrapper home-container-wrapper">
            <div class="aspect-ratio-box">
              <div class="aspect-ratio-box-inside">
                <ng-container
                  *ngIf="homePriorityList.length === 1; then priorityImageTemplate else prioritySwiperTemplate">
                </ng-container>
                <ng-template #priorityImageTemplate>
                  <div class="aspect-ration-img-box" (click)="setTargetNavigation(homePriorityList[0])">
                    <img class="ya_image" [src]="homePriorityList[0].imagePhoto" alt="">
                    <ng-container *ngIf="homePriorityList[0].show_label">
                      <div class="home-label-content">
                        <h2>{{homePriorityList[0].label}}</h2>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
                <ng-template #prioritySwiperTemplate>
                  <swiper class="swiper-container" [config]="homePriorityTileconfig">
                    <ng-container *ngFor="let homePriorityTile of homePriorityList">
                      <div class="home-swiper-item" (click)="setTargetNavigation(homePriorityTile)">
                        <img class="ya_image" [src]="homePriorityTile.imagePhoto" alt="">
                        <ng-container *ngIf="homePriorityTile.show_label">
                          <div class="home-label-content">
                            <h2>{{homePriorityTile.label}}</h2>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </swiper>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="hasHomeTile">
          <ng-container *ngFor="let homeTile of homeTileList">
            <div a11y_Button class="home-tile-container home-container-wrapper">
              <div class="aspect-equal-ratio-box">
                <div class="aspect-ratio-box-inside" (click)="setTargetNavigation(homeTile)">
                  <div class="aspect-ration-img-box">
                    <img class="ya_image" [src]="homeTile.imagePhoto" alt="">
                    <ng-container *ngIf="homeTile.show_label">
                      <div class="home-label-content">
                        <h2>{{homeTile.label}}</h2>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="canExpand()">
        <a class="desktop-tile-button" [class.rotate]="areDesktopTilesExpanded" (click)="expandDesktopTiles()">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-expand_more"></div>
        </a>
      </ng-container>

      <!--New Module tiles for desktop end-->

      <!--<mat-tab label="locations">
      <div class="location" #locationListView>
        <ng-container *ngFor="let location of locationList">
          <div class="location-content" (click)="navigateToLocationDetail(location.hyp_cus_nr)">
            <h2>
              {{location.label}}
            </h2>
          </div>
        </ng-container>
      </div>
    </mat-tab>-->
    </ng-container>
    <ng-container *ngIf="locations && locations.length > 0">
      <div class="standorte" [class.swiperLess]="locations.length < 3">
        <div class="speisekarte-subtitle">
          <div class="speisekarte-content">
            <h2>{{navigationTitleLocation.label}}</h2>
          </div>
        </div>
        <div class="slick-slider">
            <swiper class="swiper-container" [config]="locationSliderconfig" #swiperStandorte
              (init)="resizeSwiper(swiperStandorte)">
            <ng-container *ngFor="let location of sortlocation">
              <div>
                <div a11y_Button class="location" (click)="navigateToLocationDetail(location.hyp_cus_nr)">
                  <div class="img">

                    <div class="aspect-ratio-box menugroup-item__img">
                      <div class="aspect-ratio-box-inside">
                        <div class="aspect-ration-img-box">
                          <img class="ya_image" [src]="location.image_photo" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="gradient"></div>
                  </div>

                  <div class="content">
                    <h2>{{location.label}}</h2>
                    <p>{{location.street}}<br>{{location.location}}</p>
                    <h3 langkey="phGlobal_OpenTime"></h3>
                    <div class="timetoday">
                      <p><span langkey="phHome_Today"></span>:</p>
                      <p class="time">{{location.openTime}}</p>
                    </div>
                    <div class=menugroup-item__forwardicon>
                      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </swiper>
        </div>
      </div>
    </ng-container>
    <ng-container>
      <!--<mat-tab label="locations">
      <div class="location" #locationListView>
        <ng-container *ngFor="let location of locationList">
          <div class="location-content" (click)="navigateToLocationDetail(location.hyp_cus_nr)">
            <h2>
              {{location.label}}
            </h2>
          </div>
        </ng-container>
      </div>
    </mat-tab>-->

      <ng-container *ngIf="itemGroups && itemGroups.length > 0">
        <div class="speisekarte" [class.swiperLess]="itemGroups.length < 4">
          <div class="speisekarte-subtitle">
            <div class="speisekarte-content">
              <h2>{{navigationTitleMenu.label}}</h2>
            </div>
          </div>
          <div class="slick-slider">
            <swiper slider class="swiper-container" [config]="itemGroupSliderconfig" #swiperSpeisekarte
              (init)="resizeSwiper(swiperSpeisekarte)">
              <ng-container *ngFor="let itemGroup of itemGroups">
                <div>
                  <div a11y_Button class="warengruppe">
                    <div a11y_NoAria class="img" routerLink="/menuservice">
                      <div class="aspect-ratio-box menugroup-item__img">
                        <div class="aspect-ratio-box-inside">
                          <div class="aspect-ration-img-box">
                            <img class="ya_image" [src]="itemGroup.imagePhoto" alt="" />
                          </div>
                        </div>
                      </div>
                      <div class="gradient"></div>
                    </div>
                    <div class="content">
                      <a a11y_NoAria routerLink="/menuservice">
                        <div *ngIf="itemGroup.use_label" class="title ya-header-2">{{itemGroup.label}}</div>
                        <div class="menugroup-item__forwardicon" [ngClass]="{'ya-no-header-2': !itemGroup.use_label}">
                          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>
            </swiper>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- Add INHOUSEBUTTON -->
    <ng-container *ngIf="showInHouseTableButton">
      <ya-inHouseTableButton></ya-inHouseTableButton>
    </ng-container>
    <!-- Remote group order button -->
    <ng-container *ngIf="showRemoteGroupOrderHomeButton$|async">
      <ya-remoteGroupHomeButton></ya-remoteGroupHomeButton></ng-container>
    <!-- Remote group summary button -->
    <ya-remoteGroupHomeButton *ngIf="(groupStatusFinished$ | async) && (displaySummaryButton$ | async)"
      [displaySummary]="true">
    </ya-remoteGroupHomeButton>

    <!-- <div id="menugroup-container" class="ya-typography">
    <ya-subheader [hasContent]="true">
   
      </ng-container>
    </ya-subheader>
    <div class="ya-page-content ya-page-content--webshop ya-page-content--inset">
      <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
      <ng-template #pageTemplate>
        <div class="menugroup-item-container">
          <ng-container *ngFor="let itemGroup of itemGroups">
            <div class="menugroup-item">
              <a (click)="navigateToMenuList(itemGroup)">
                <div class="aspect-ratio-box menugroup-item__img">
                  <div class="aspect-ratio-box-inside">
                    <div class="aspect-ration-img-box">
                      <img class="ya_image" [src]="itemGroup.imagePhoto" alt="" />
                    </div>
                  </div>
                </div>
                <div class=menugroup-item__bar>
                  <div class=menugroup-item__label>
                    <ng-container *ngIf="itemGroup.show_label">
                      <h3>{{itemGroup.label}}</h3>
                    </ng-container>
                  </div>
                  <div class=menugroup-item__forwardicon>
                    <div class="inline-icon" inlineSVG="keyboard_backspace.svg"></div>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>
      </ng-template>
      <ng-template #emptyTemplate>
        <ya-emptypage></ya-emptypage>
      </ng-template>
    </div>
  </div>-->
  </div>